<div
  class="component-container
          w-full
          flex flex-col
          justify-center items-center
          space-y-[2.4rem]"
>
  <div
    class="heading flex flex-row
          justify-center items-center
          text-[2.8rem] font-poppins
          font-semibold text-cool-grey"
  >
    Update Password
  </div>
  <form class="form flex flex-col justify-center items-center w-full">
    <app-password-input
      class="w-full"
      [parentFormGroup]="form"
      controlName="currentPassword"
      placeholder="Old Password"
      label="Old Password"
      type="small"
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['currentPassword']"
    ></app-password-input>
    <app-password-input
      class="w-full"
      [parentFormGroup]="form"
      controlName="newPassword"
      placeholder="New Password"
      label="New Password"
      type="small"
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['newPassword']"
      [tooltip]="true"
    ></app-password-input>
    <app-password-input
      class="w-full"
      [parentFormGroup]="form"
      controlName="confirmNewPassword"
      placeholder="Confirm New Password"
      label="Confirm New Password"
      type="small"
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['confirmNewPassword']"
    ></app-password-input>
  </form>
  <div class="actions-section w-full">
    <app-primary-button
      (click)="updatePassword()"
      type="small">
      UPDATE PASSWORD
    </app-primary-button>
  </div>
</div>
